var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-template-mutate-posts"},[(_vm.isActive)?_c('Posts',_vm._g(_vm._b({staticClass:"posts--scoped"},'Posts',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }